/**
 * The privacy policy a user is shown, and which version of it.
 *
 * Bump PRIVACY_POLICY_VERSION together with PRIVACY_POLICY_VERSION in
 * mushroom-bank/lambda/routes/auth.py whenever the text changes. The backend
 * records its own copy against each registration, so consent is tied to the
 * text a person actually saw.
 *
 * Both app stores require a publicly reachable policy URL before an app can
 * even be submitted. Set VITE_PRIVACY_POLICY_URL to that hosted page once the
 * institute publishes one; until then links go to the in-app draft at
 * /privacy, which says plainly that it is a placeholder.
 */
export const PRIVACY_POLICY_VERSION = '2026-09-draft';

// REACT_APP_PRIVACY_POLICY_URL is the old name, read for one release so a
// builder not yet updated keeps pointing at the published policy rather than
// silently reverting every store listing to the in-app draft.
export const PRIVACY_POLICY_URL =
  process.env.VITE_PRIVACY_POLICY_URL
  || process.env.REACT_APP_PRIVACY_POLICY_URL
  || '/privacy';

export const isExternalPolicy = () => /^https?:\/\//i.test(PRIVACY_POLICY_URL);
